module.exports = require('./dist/commonjs/advanced');



//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-query/advanced.js
// module id = 1328
// module chunks = 27